__turbopack_context__.v({
  "content-pos-bottom-center": "CoreCover-module-scss-module__nINJBa__content-pos-bottom-center",
  "content-pos-bottom-left": "CoreCover-module-scss-module__nINJBa__content-pos-bottom-left",
  "content-pos-bottom-right": "CoreCover-module-scss-module__nINJBa__content-pos-bottom-right",
  "content-pos-center-center": "CoreCover-module-scss-module__nINJBa__content-pos-center-center",
  "content-pos-center-left": "CoreCover-module-scss-module__nINJBa__content-pos-center-left",
  "content-pos-center-right": "CoreCover-module-scss-module__nINJBa__content-pos-center-right",
  "content-pos-top-center": "CoreCover-module-scss-module__nINJBa__content-pos-top-center",
  "content-pos-top-left": "CoreCover-module-scss-module__nINJBa__content-pos-top-left",
  "content-pos-top-right": "CoreCover-module-scss-module__nINJBa__content-pos-top-right",
  "cover": "CoreCover-module-scss-module__nINJBa__cover",
  "cover-content": "CoreCover-module-scss-module__nINJBa__cover-content",
  "image": "CoreCover-module-scss-module__nINJBa__image",
  "overlay": "CoreCover-module-scss-module__nINJBa__overlay",
});
